import { render, staticRenderFns } from "./IdentidadIcon.vue?vue&type=template&id=0daf5f8a"
import script from "./IdentidadIcon.vue?vue&type=script&lang=js"
export * from "./IdentidadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports